import React from 'react';
import PropTypes from 'prop-types';
import { TNoResultSuggestion } from '../_component_types/no_result_suggestion/no_result_suggestion';
import { Suggestion } from './suggestion';
import { SuggestionTypes } from '../../constants/suggestions/suggestion_types';
import getTranslatedText from '../../helper/get_translated_text';

function Suggestions({ suggestions, onImproveClick, onRemoveClick }) {
    return (
        <div className="no-results__suggestions no-results-suggestions">
            {suggestions.map(suggestion => {
                let suggestionTranslationKey;
                let suggestionPlaceholder;
                let onClickCallback;

                if (suggestion.type === SuggestionTypes.REMOVABLE) {
                    suggestionTranslationKey = suggestion.label === ''
                        ? 'catalog-items-suggestion-remove-no-value'
                        : 'catalog-items-suggestion-remove';

                    suggestionPlaceholder = {
                        filter: getTranslatedText(suggestion.facetNameTranslationKey),
                        value: getTranslatedText(suggestion.label)
                    };

                    onClickCallback = () => onRemoveClick(suggestion.facetName);
                } else if (suggestion.type === SuggestionTypes.IMPROVABLE) {
                    suggestionTranslationKey = 'catalog-items-suggestion-improvement';
                    suggestionPlaceholder = {
                        filter: getTranslatedText(suggestion.facetNameTranslationKey),
                        improvement: suggestion.improvementLabel
                    };
                    onClickCallback = () => onImproveClick(suggestion.facetName, suggestion.improvementValue);
                }

                return (
                    <Suggestion
                        translationKey={suggestionTranslationKey}
                        placeholder={suggestionPlaceholder}
                        key={suggestion.facetNameTranslationKey}
                        onClick={onClickCallback}
                    />
                );
            })}
        </div>
    );
}

Suggestions.propTypes = {
    suggestions: PropTypes.arrayOf(TNoResultSuggestion).isRequired,
    onImproveClick: PropTypes.func.isRequired,
    onRemoveClick: PropTypes.func.isRequired,
};

export { Suggestions };
